exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-container{margin:0 20px;padding:0 calc((100% - 1040px) / 2)}", ""]);

// exports
